import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BackButton.css';

const BackButton = ({
  onClick,
  to,
  text = 'Back',
  onBeforeClick,
  className = '',
  ariaLabel
}) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    if (onBeforeClick) {
      onBeforeClick(event);
    }

    if (onClick) {
      onClick(event);
      return;
    }

    if (to) {
      navigate(to);
      return;
    }

    navigate(-1);
  };

  return (
    <button
      type="button"
      className={`back-button ${className}`.trim()}
      onClick={handleClick}
      aria-label={ariaLabel || text}
    >
      <span className="back-arrow">&#8592;</span>
      <span className="back-button-text">{text}</span>
    </button>
  );
};

export default BackButton;
